export default {
  translation: {
    welcome: 'Witaj w React i react-i18next',
    hello: 'Cześć, {{name}}!',
    goodMorning: 'Dzień dobry, {{name}}!',
    goodAfternoon: 'Dzień dobry, {{name}}!',
    goodEvening: 'Dobry wieczór, {{name}}!',

    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    areYouSure: 'Na pewno?',
    back: 'Wróć',
    backToHome: 'Wróć do strony głównej',
    close: 'Zamknij',
    you: 'Ty',
    save: 'Zapisz',

    home: {
      activeChecklists: 'Aktywne Checklisty',
      history: 'Historia',
      recentTemplates: 'Ostatnio używane szablony',
    },

    onboarding: {
      heading: 'Zacznij',
      body: 'Stwórz swoją pierwszą checklistę lub szablon, aby zacząć.',
    },

    settings: {
      title: 'Ustawienia',
      description: 'Zarządzaj ustawieniami swojego konta.',
      language: 'Język',
      preferences: 'Preferencje',
      profile: 'Profil',
      organization: 'Organizacja',
    },

    notifications: {
      title: 'Powiadomienia',
      configured: 'Powiadomienia push są włączone dla tego urządzenia.',
      notConfigured: 'Powiadomienia push nie są skonfigurowane dla tego urządzenia.',
      unsupported: 'Powiadomienia push nie są obsługiwane w tej przeglądarce.',
      denied: 'Powiadomienia push zostały zablokowane. Włącz je w ustawieniach przeglądarki.',
      enable: 'Włącz powiadomienia',
      disable: 'Wyłącz powiadomienia',
      disableSuccess: 'Powiadomienia push zostały wyłączone.',
      disableError: 'Nie udało się wyłączyć powiadomień push.',
      enableSuccess: 'Powiadomienia push zostały włączone.',
      enableError: 'Nie udało się włączyć powiadomień push.',
    },

    profile: {
      name: 'Imię',
      namePlaceholder: 'Wpisz swoje imię',
      nameDescription: 'Twoja nazwa wyświetlana widoczna dla innych.',
      email: 'Email',
      emailDescription: 'Twój adres email nie może być tutaj zmieniony.',
      saveChanges: 'Zapisz zmiany',
      saving: 'Zapisywanie...',
      updateSuccess: 'Profil zaktualizowany pomyślnie!',
      updateError: 'Nie udało się zaktualizować profilu. Spróbuj ponownie.',
    },

    templates: {
      addTemplate: 'Dodaj szablon',
      addTemplateDescription:
        'Dodaj szablon do swojej kolekcji. Kliknij zapisz, gdy skończysz.',

      templateName: 'Nazwa',
      createTemplate: 'Zapisz szablon',
      addNewItem: 'Dodaj nowy krok',

      created: 'Szablon utworzony pomyślnie!',
      deleted: 'Szablon usunięty pomyślnie!',
      deleteConfirmation:
        'Czy na pewno chcesz usunąć ten szablon? To nie wpłynie na żadne checklisty utworzone z tego szablonu.',
      add: 'Dodaj',
    },

    checklists: {
      title: 'Checklista',
      description: 'Zarządzaj swoimi checklistami.',
      addChecklist: 'Dodaj Checklistę',
      addChecklistDescription:
        'Dodaj Checklistę do swojej kolekcji. Kliknij zapisz, gdy skończysz.',
      editItem: 'Edytuj krok',

      checklistName: 'Nazwa',
      checklistDescription: 'Opis',
      checklistDescriptionMedia: 'Obraz/Wideo',
      createChecklist: 'Dodaj Checklistę',

      deleteConfirmation:
        'Ta checklista i wszystkie jej elementy zostaną usunięte.',

      started: 'Checklista rozpoczęta pomyślnie!',
      deleted: 'Checklista usunięta pomyślnie!',
      created: 'Checklista utworzona pomyślnie!',

      rerun: 'Ponów',
      completed: 'Ukończona',
      itemsCompleted: 'kroków ukończonych',
      itemsSkipped: 'kroków pominiętych',

      finish: 'Zakończ',
      checklistNotFinished: 'Checklista niezakończona',
      checklistNotFinishedDescription:
        'Masz jeszcze kroki do ukończenia. Czy na pewno chcesz zakończyć checklistę?',

      addNewItem: 'Dodaj nowy krok',
      add: 'Dodaj',

      addImage: 'Dodaj obraz',
      viewImage: 'Zobacz obraz',
      viewVideo: 'Zobacz wideo',

      skip: 'Pomiń',
      unskip: 'Cofnij',
      mediaRequired: 'Wymagane media',
      requireMediaProof: 'Wymagaj dowodu w mediach',
      requireMediaProofHelp:
        'Wymagaj obrazu lub wideo przed ukończeniem tego elementu.',
      requiresMediaToComplete:
        'Ten element wymaga dowodu w mediach - prześlij obraz lub wideo, aby ukończyć',

      uploadFile: 'Prześlij plik',
      viewFile: 'Zobacz plik',
      uploadSuccess: 'Plik został pomyślnie przesłany!',
      uploadError: 'Wystąpił błąd podczas przesyłania pliku.',

      assign: 'Przypisz',
      unassign: 'Usuń',
      assignChecklist: 'Przypisz Checklistę',
      assignChecklistDescription:
        'Przypisz tę checklistę do użytkownika. Jeśli przypiszesz siebie, Checklista będzie widoczna tylko do Ciebie.',

      deleteItemTitle: 'Usuń element',
      deleteItemDescription:
        'Czy na pewno chcesz usunąć ten element? Tej operacji nie można cofnąć.',
    },
  },
}
